// Kategori bazlı içerik jeneratörleri — SEO landing template tarafından tüketilir.
// Her sayfa `category` alanına göre "Bu durumda ne yapılır?" ve "Gerekli belgeler"
// bölümlerini otomatik doldurur. Sayfaya özgü nüans için config `whatToDoNote`,
// `extraDocs` ve `faq` ile override edilebilir.

const CATEGORY_LABELS = {
  "telecom-internet": "İnternet & TV",
  "mobile": "Mobil Hat",
  "digital": "Dijital Üyelik",
  "ecommerce": "E-ticaret",
  "dilekce": "Dilekçe & İtiraz",
};

export function getCategoryLabel(cat) {
  return CATEGORY_LABELS[cat] || "";
}

export function getWhatToDo(config) {
  const c = config.category;
  const co = config.prefill?.company || "kurum";

  if (c === "telecom-internet") {
    return [
      { title: `${co} resmi iptal kanalını kullanın`, text: `Çevrimiçi hesabınız, mobil uygulama, çağrı merkezi veya bayi üzerinden ${co} iptal talebinizi iletin.` },
      { title: "Başvuru kanıtınızı saklayın", text: "Ekran görüntüsü, kayıt numarası veya çağrı işlem numarasını mutlaka arşivleyin — sonraki adımlarda kilit rol oynar." },
      { title: "Cayma bedeli çıkarsa yazılı itiraz edin", text: "Abonelik İptal, taahhüt/cayma bedeli için mevzuata uygun itiraz metnini sizin için hazırlar." },
      { title: "Sonuç alınamazsa Hakem Heyeti", text: "Belgeleri toparlayın; Tüketici Hakem Heyeti başvurusu için dosyanızı Abonelik İptal ile oluşturabilirsiniz." },
    ];
  }
  if (c === "mobile") {
    return [
      { title: `${co} bayisine başvurun`, text: `Kimliğinizle ${co} bayisine giderek fesih/iptal formunu doldurun ve kayıt numarasını alın.` },
      { title: "Yazılı fesih belgenizi saklayın", text: "Formun bir nüshasını mutlaka bulundurun; ileride cayma bedeli veya fatura itirazında delil olur." },
      { title: "Son faturayı ve cayma bedelini kontrol edin", text: "Haksız bir kalem varsa Abonelik İptal ile itiraz metninizi hazırlayabilirsiniz." },
      { title: "Numara taşıma vs. iptal ayrımına dikkat", text: "Hattı başka operatöre taşıyorsanız süreç farklıdır; iptalde hat kapatılır ve varsa cayma bedeli tahakkuk edebilir." },
    ];
  }
  if (c === "digital") {
    return [
      { title: `${co} hesabınızdan iptal edin`, text: `Hesap → Abonelik → İptal Et adımlarını ${co} arayüzünde takip edin ve iptal onayı e-postasını saklayın.` },
      { title: "Ödeme dönemi sonuna kadar erişim sürer", text: "İptal ederseniz mevcut dönem sonuna kadar hizmet açık kalır, sonrasında kesilir; yeni tahsilat olmamalıdır." },
      { title: "Beklenmeyen ücret gelirse belgeleyin", text: "Kart ekstresi, e-posta ve iptal onayı ekran görüntüsünü saklayın." },
      { title: "İade edilmeyen tutar için itiraz", text: "Yeni ücret çekildiyse Abonelik İptal ile iade talebi ve gerekirse Hakem Heyeti başvurusu için dosya oluşturabilirsiniz." },
    ];
  }
  if (c === "ecommerce") {
    return [
      { title: `${co} üzerinden talep açın`, text: `${co} sipariş detayında iade/iptal/ürün sorunu talebini açın ve talep numarasını not edin.` },
      { title: "Kargo & ödeme belgelerini saklayın", text: "Kargo takip numarası, kargo fişi, ödeme dekontu ve ürün fotoğraflarını arşivleyin." },
      { title: "14 gün içinde iade beklenir", text: "Mesafeli Sözleşmeler Yönetmeliği kapsamında iade tutarınız 14 gün içinde ödeme yönteminize dönmelidir." },
      { title: "Sonuç alamazsanız yazılı itiraz", text: "Abonelik İptal ile satıcıya/platforma yazılı itiraz metninizi hazırlayıp gerekirse Hakem Heyeti başvurusu yapabilirsiniz." },
    ];
  }
  // dilekce
  return [
    { title: "Konuya özel belgelerinizi bir araya getirin", text: "Fatura, sözleşme, ödeme dekontu, ekran görüntüsü ve yazışmalar." },
    { title: "Karşı tarafa yazılı olarak başvurun", text: "Abonelik İptal ile hazırladığınız metni e-posta, iadeli taahhütlü mektup veya destek kanalına gönderin." },
    { title: "Başvuru kayıt numarasını saklayın", text: "Sonraki adımlarda ve olası hakem heyeti başvurusunda mutlaka gerekir." },
    { title: "Cevap yoksa Hakem Heyeti dosyası hazırlayın", text: "Belgeleriniz tamamsa Abonelik İptal başvuru dilekçenizi ve kontrol listenizi hazırlar." },
  ];
}

export function getDocs(config) {
  const c = config.category;
  const extra = config.extraDocs || [];
  const base = {
    "telecom-internet": [
      "Son fatura veya ekstre",
      "İptal başvurusu ekran görüntüsü / işlem numarası",
      "Ödeme dekontu",
      "Modem / cihaz iade tutanağı (varsa)",
      "Kurum yazışmaları / ekran görüntüleri",
    ],
    "mobile": [
      "Kimlik bilgisi",
      "Son fatura ve önceki dönem faturaları",
      "Bayi fesih başvuru formu",
      "Ödeme dekontu",
      "Kurum yazışmaları",
    ],
    "digital": [
      "Hesap e-postası ve kullanıcı adı",
      "Son ödeme dekontu veya kart ekstresi",
      "İptal onayı e-postası / ekran görüntüsü",
      "Uygulama ayarlarındaki abonelik ekran görüntüsü",
    ],
    "ecommerce": [
      "Sipariş numarası ve tarih",
      "Ödeme dekontu veya kart ekstresi",
      "Kargo / iade fişi ve takip numarası",
      "Ürün fotoğrafı (ayıp veya yanlış gönderim varsa)",
      "Satıcı / platform yazışmaları",
    ],
    "dilekce": [
      "Fatura veya sipariş belgesi",
      "Ödeme dekontu",
      "Kurum veya satıcı yazışmaları",
      "Başvuru kayıt numarası (varsa)",
      "Kimlik bilgisi",
    ],
  };
  return [...(base[c] || []), ...extra];
}

// SEO landing'ler arası mantıksal iç linkleme.
// Her sayfa ayni kategorideki en fazla 3 kardeşe + 1-2 ilgili genel sayfaya link verir.
const CATEGORY_HUBS = {
  "telecom-internet": { slug: "abonelik-iptali", label: "Abonelik iptali rehberi" },
  "mobile": { slug: "abonelik-iptali", label: "Abonelik iptali rehberi" },
  "digital": { slug: "abonelik-iptali", label: "Dijital abonelik iptali" },
  "ecommerce": { slug: "iade-itiraz", label: "İade & itiraz süreci" },
  "dilekce": { slug: "tuketici-hakem-heyeti", label: "Tüketici Hakem Heyeti başvurusu" },
};

export function getRelated(allPages, current) {
  const siblings = allPages
    .filter((p) => p.category === current.category && p.slug !== current.slug)
    .slice(0, 3)
    .map((p) => ({ slug: p.slug, label: p.title }));
  const hub = CATEGORY_HUBS[current.category];
  if (hub && !siblings.some((s) => s.slug === hub.slug)) {
    siblings.push(hub);
  }
  return siblings;
}
